import React from 'react';

export interface FreeInputFeedbackAnswer {
  text: string;
}

export interface FreeInputFeedbackViewProps {
  item: {
    id: string;
    required?: boolean;
    config: { question?: string; max_length?: number | null };
  };
  mode: 'learner' | 'preview';
  value?: FreeInputFeedbackAnswer;
  onChange?: (value: FreeInputFeedbackAnswer) => void;
  disabled?: boolean;
}

const FreeInputFeedbackView: React.FC<FreeInputFeedbackViewProps> = ({
  item,
  mode,
  value,
  onChange,
  disabled,
}) => {
  const text = value?.text ?? '';
  const maxLen = item.config.max_length;
  const overLimit = maxLen != null && text.length > maxLen;

  return (
    <div className="space-y-2">
      {/* In learner mode the parent FeedbackPage renders the prompt above
          the input, so we only render the question text in preview mode. */}
      {mode === 'preview' && (
        <p className="font-medium text-text-primary">
          {item.config.question}
          {item.required && <span className="text-error-500 ml-1">*</span>}
        </p>
      )}
      <p className="text-xs font-bold text-text-primary uppercase tracking-wide">
        Answer
      </p>
      <textarea
        value={text}
        onChange={(e) => {
          if (disabled || mode === 'preview') return;
          onChange?.({ text: e.target.value });
        }}
        disabled={disabled}
        rows={4}
        maxLength={maxLen ?? undefined}
        placeholder="Type your answer here…"
        className={`w-full px-4 py-3 rounded-2xl border bg-surface-primary text-text-primary placeholder:text-text-tertiary text-sm resize-y focus:outline-none focus:ring-2 focus:ring-primary-500/30 focus:border-primary-500 disabled:opacity-60 ${
          overLimit ? 'border-error-500' : 'border-border-secondary'
        }`}
      />
      {maxLen != null && (
        <div
          className={`text-xs text-right ${
            overLimit ? 'text-error-500' : 'text-text-tertiary'
          }`}
        >
          {text.length} / {maxLen}
        </div>
      )}
    </div>
  );
};

export default FreeInputFeedbackView;
